<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableBillingWarningDate"
      style="width: 100.1%;margin-top:10px"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['monitor:billingMonitor:log']"
          >{{ $t("alarms.common.operationLog") }}</Button
        >
        <Button
          type="warning"
          size="small"
          @click="addOrUpdateHandle(row.id, row.accountType)"
          v-hasPermission="['monitor:billingMonitor:edit']"
          >{{ $t("alarms.common.edit") }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="billingWarningModal = true"
            v-hasPermission="['monitor:billingMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <alert-rule-operation-log
      v-if="alertRuleOperationLogVisible"
      ref="alertRuleOperationLog"
    ></alert-rule-operation-log>
    <!-- 删除报警规则模式框 -->
    <Modal v-model="billingWarningModal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ alertRuleName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removebillingWarning()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 弹窗，新增/编辑 -->
    <add-or-update-billing-warning
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-billing-warning>
  </div>
</template>
<script>
import AlertRuleOperationLog from "../common/AlertRuleOperationLog.vue";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import AddOrUpdateBillingWarning from "../billing/AddOrUpdateBillingWarning";
var tableBillingWarningVue = {};
export default {
  name: "TableBillingWarning",
  components: {
    AddOrUpdateBillingWarning,
    AlertRuleOperationLog
  },
  data() {
    return {
      companyId: "",
      alertRuleOperationLogVisible: false,
      addOrUpdateVisible: false,
      isShowField: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      billingWarningModal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      alertRuleName: "",
      stateType: ["enabled", "disabled"],
      columns: [
        {
          title: this.$t("alarms.common.billingType"),
          key: "billingTypeName",
          fixed: "left",
          minWidth: 120
        },
        {
          title: this.$t("alarms.common.accountName"),
          key: "accountName",
          minWidth: 150
        },
        {
          title: this.$t("alarms.common.accountGroupName"),
          key: "accountGroupName",
          minWidth: 140
        },
        {
          title: this.$t("alarms.common.region"),
          key: "region",
          minWidth: 140
        },
        {
          title: this.$t("alarms.common.resourceType"),
          key: "resourceTypeName",
          minWidth: 140
        },
        {
          title: this.$t("alarms.common.alertRuleName"),
          key: "alertRuleName",
          minWidth: 140
        },
        {
          title: this.$t("alarms.common.status"),
          key: "state",
          minWidth: 140,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  // 数据库0 enabled,1 disabled
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.state == "enabled" // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t("alarms.common.enable")
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t("alarms.common.disable")
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t("alarms.common.monitorIndex"),
          key: "monitorIndexName",
          minWidth: 140
        },
        {
          title: this.$t("alarms.common.alertRuleDesc"),
          key: "alertRuleDesc",
          minWidth: 140
        },
        {
          title: this.$t("alarms.common.contact"),
          key: "contactNameList",
          minWidth: 140
        },
        {
          title: this.$t("alarms.common.scanType"),
          key: "scanTypeName",
          minWidth: 140
        },
        {
          title: this.$t("common.operation"),
          slot: "delete",
          fixed: "right",
          minWidth: 200
        }
      ],
      tableBillingWarningDate: []
    };
  },
  beforeCreate: function() {
    tableBillingWarningVue = this;
  },
  created() {
    // 获取BillingWarningSearch里面的搜索内容
    eventBus.$on("alertRuleSearchName", function(val) {
      tableBillingWarningVue.alertRuleSearchName = val;
    });
    // 获取BillingWarningSearch里面的搜索内容
    eventBus.$on("resourceType", function(val) {
      tableBillingWarningVue.resourceType = val;
    });

    // 获取BillingWarningSearch里面的搜索内容
    eventBus.$on("billingType", function(val) {
      tableBillingWarningVue.billingType = val;
    });

    // 获取BillingWarningSearch里面的搜索内容
    eventBus.$on("accountName", function(val) {
      tableBillingWarningVue.accountName = val;
    });

    // 获取BillingWarningSearch里面的搜索内容
    eventBus.$on("companyId", function(val) {
      tableBillingWarningVue.companyId = val;
    });

    // 获取BillingWarningSearch里面的搜索内容
    eventBus.$on("monitorIndex", function(val) {
      tableBillingWarningVue.monitorIndex = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableBillingWarningVue.getBillingWarningData();
    },
    // 分页显示数据
    /****************************************************/
    getBillingWarningData: function() {
      //报警规则列表分页
      this.$api.alertRule
        .pageAlertRule({
          companyId: tableBillingWarningVue.companyId,
          alertRuleName: tableBillingWarningVue.alertRuleSearchName,
          monitorIndex: tableBillingWarningVue.monitorIndex,
          resourceType: tableBillingWarningVue.resourceType,
          accountName: tableBillingWarningVue.accountName,
          billingType: tableBillingWarningVue.billingType,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 2
        })
        .then(res => {
          this.tableBillingWarningDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;

          for (var i = 0; i < this.tableBillingWarningDate.length; i++) {
            // 状态
            this.tableBillingWarningDate[i].state = this.stateType[
              this.tableBillingWarningDate[i].state
            ];
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableBillingWarningVue.getBillingWarningData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableBillingWarningVue.getBillingWarningData();
    },
    // 销毁alertRuleSearchName
    beforeDestroy: function() {
      eventBus.$off("alertRuleSearchName");
    },
    // switch
    /****************************************************/
    switch(index) {
      this.index = index;
      // 打开是true,0启用 1禁用
      if (this.tableBillingWarningDate[index].state == "enabled") {
        this.changeStatusMessage(
          this.tableBillingWarningDate[index].id,
          "state",
          1
        );
      } else {
        this.changeStatusMessage(
          this.tableBillingWarningDate[index].id,
          "state",
          0
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      // 编辑状态
      this.$api.alertRule
        .changeStatus({
          id: id,
          state: value
        })
        .then(res => {
          tableBillingWarningVue.getBillingWarningData();
        });
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.alertRuleName = this.tableBillingWarningDate[index].alertRuleName;
    },
    removebillingWarning: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //报警规则删除
      this.$api.alertRule
        .deleteAlertRule("id", this.tableBillingWarningDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableBillingWarningVue.getBillingWarningData();
            this.isDisable = false;
            this.modal_loading = false;
            this.billingWarningModal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 编辑报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function(id, accountType) {
      let currentSelectedCompanyId = -1;
      if (tableBillingWarningVue.companyId != "") {
        currentSelectedCompanyId = tableBillingWarningVue.companyId;
      }
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, accountType, currentSelectedCompanyId);
      });
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.alertRuleOperationLogVisible = true;
      this.$nextTick(function() {
        this.$refs.alertRuleOperationLog.getAlertRuleOperationLogData(row);
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/billing/TableBillingWarning.vue